// this is required for envs that don't support arr.flat, i.e., JSDOM
// babel polyfill doesn't package flat polyfill
export default function flat(arr) {
	if (arr.flat) return arr.flat(Infinity);

	return arr.reduce(function reducer(acc, val) {
		if (Array.isArray(val)) val.reduce(reducer, acc);
		else acc.push(val);
		return acc;
	}, []);
}
